<template>
	<div class="carousel--container">
		<div class="next--arrow" @click="previous()">&#9664;</div>
		<div class="puzzle-media-objects">
			<div
				v-for="mediaObjectURL of mediaObjectURLS"
				:key="mediaObjectURL"
				:style="{ backgroundImage: `url(${mediaObjectURL})` }"
				@click="$emit('emitSelectedImage', mediaObjectURL)"
				class="carousel-images"
			></div>
		</div>
		<div class="prev-arrow" @click="next()">&#9654;</div>
	</div>
</template>

<script>
export default {
	name: 'carousel',
	data() {
		return {
			size: 3,
			current: 1,
			mediaObjectsURL: null,
			mediaObjectURLS: null,
		};
	},
	methods: {
		getMediaURLS() {
			return this.mediaObjectsURL.slice(this.size * this.current - this.size, this.size * this.current);
		},
		next() {
			if (this.current >= 1 && this.current < this.mediaObjectsURL.length / this.size) {
				this.current++;
				this.mediaObjectURLS = this.getMediaURLS();
			}
		},
		previous() {
			if (this.current > 1) {
				this.current--;
				this.mediaObjectURLS = this.getMediaURLS();
			}
		},
	},
	async mounted() {
		const { game } = await this.$store.getters.getArticleByType('puzzle');
		const mediaObjects = [...new Set(game.mediaObjects)];
		const url = this.$store.state.dataSourceURL;
		this.mediaObjectsURL = mediaObjects.map((mediaObject) => {
			return `${url}apps/media-${mediaObject}/2048`;
		});
		this.mediaObjectURLS = this.getMediaURLS();
	},
};
</script>
